module.exports = __webpack_public_path__ + "img/logo.f9ce6221.png";